import { createFileRoute, Link } from '@tanstack/react-router';

import { UserManagement } from '@apps/web/components/settings/user_management';
import { Button } from '@apps/web/components/ui/button';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';
import { isOrganizationAdmin } from '@apps/web/lib/organization_permissions';
import { useUserProfile } from '@apps/web/swr_data_fetching/current_user_queries';

export const Route = createFileRoute('/_app/settings/team-members')({
    component: TeamMembersPage,
});

function TeamMembersPage() {
    const { organizationId } = useSettingsGates();
    const { data: profile } = useUserProfile({
        reason: 'team-notification-defaults-entry',
    });
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Team Members"
            headerAction={
                isOrganizationAdmin(profile, organizationId) ? (
                    <div className="flex flex-wrap gap-2">
                        <Button variant="outline" asChild={true}>
                            <Link to="/settings/team-members/defaults">
                                Team defaults
                            </Link>
                        </Button>
                        <Button asChild={true}>
                            <Link to="/settings/team-members/bulk">
                                Update notifications
                            </Link>
                        </Button>
                    </div>
                ) : undefined
            }
            description="Manage your team: invite users, change roles, and select a teammate to manage their notifications."
        >
            <UserManagement
                organizationId={organizationId}
                variant="embedded"
                showJoinedColumn={false}
                enableNotificationSettings={true}
            />
        </SettingsPageShell>
    );
}
